import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderStyle = _resolveComponent("PageHeaderStyle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_PageHeaderStyle, {
        class: _normalizeClass(_ctx.itemClass),
        title: _ctx.itemTitle,
        "sub-title": _ctx.itemSubTitle,
        breadcrumb: _ctx.itemBreadcrumbs,
        ghost: _ctx.ghost,
        extra: _ctx.itemExtras
      }, null, 8, ["class", "title", "sub-title", "breadcrumb", "ghost", "extra"])
    ])
  ]))
}